
import { 
  MessageSquare, 
  BarChart3, 
  Settings
} from "lucide-react";
import type { MenuItem } from "../types";

export const standaloneSections: MenuItem[] = [
  {
    title: "الرسائل",
    href: "/messages",
    icon: MessageSquare,
    color: "from-green-500 to-green-600",
  },
  {
    title: "لوحة تحكم الموظف",
    href: "/employee-dashboard",
    icon: BarChart3,
    color: "from-blue-500 to-blue-600",
  },
  {
    title: "الإعدادات",
    href: "/settings",
    icon: Settings,
    color: "from-gray-600 to-gray-700",
  },
];
